module.exports = __webpack_public_path__ + "img/40_69.320ef72a.png";